import "../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/queues_options.template.htm';
import 'dhtmlxMessage';
import HandlebarsHelpers from '../../libs/handlebars/handlebars-helpers.ts';
import AgentsModel from '../models/agents.model.ts';
import QueuesCollection from '../models/queues.paginated.collection.ts';


export default GenericView.extend({
    el: '#queuesOptions',
    tagName: 'div',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	userPrivilege: null,
	id: null,
	isDisplay: false,
	listOfUnselected: [],
	listOfSelected: [],
	removeCounter: [],
	addCounter: [],
	callback: null,
	initialize: function (options) {
		var self = this;
		this.userPrivilege = options.userPrivilege;
		this.id = options.id;

		if(!this.isNewUser())
		{
			this.showActionProgressBar();
			this.model = new AgentsModel();
			var url = "rest/api/agents?filter=" + encodeURIComponent("user=" + this.id);
			this.model.fetch({
				url: url,
				success: function(response)
				{
					self.hideActionProgressBar();
				},
				error: function(response, xhr, status)
				{
					self.hideActionProgressBar();
				}
			});
		}

	},
	show: function()
	{
		this.render();
	},
	load: function(venueId)
	{
		if( venueId  == null)
		{
			this.show();
			return;
		}


		var self = this;
		if(!this.isDisplay || this.venueId != venueId)
		{

			this.clearData();
			this.initializeQueuesCollection(venueId);
			this.showActionProgressBar();
			this.queueCollection.getFirstPage();

		}

		this.venueId = venueId;
	},
	initializeQueuesCollection: function(venueId)
	{
		this.queueCollection = new QueuesCollection();
		this.queueCollection.url = 'rest/api/queues' + this.createFilters({venue: venueId});

		this.queueCollection.on('sync', this.queueSuccess, this);
		this.queueCollection.on('error', this.queueError, this);
		this.queueCollection.state.pageSize = 999;
	},
	createFilters: function(filter)
	{
		if( !filter )
			return "";

		var params = "";
		for (var key in filter) {

		  if(params != "")
				params = params + ",";

		  params = params + key + "="+filter[key];

		}

		return "?filter=" + encodeURIComponent(params);
	},
	queueSuccess: function()
	{
		var counters = {};
		if(  this.model )
			counters = this.model.toJSON();

		var countersObj = {};
		console.info(counters.length);

		for(var i = 0; i < Object.keys(counters).length; i++)
		{
			var temp = 	{};
			temp[""+counters[i].queueId] = counters[i].id ;
			countersObj = $.extend(countersObj, temp);
		}

		for(var index in this.queueCollection.models)
		{
			var obj = this.queueCollection.models[index];
			if(countersObj[""+obj.attributes.id] != null)
			{
				this.listOfSelected = this.listOfSelected.concat([{ id: countersObj[""+obj.attributes.id], queueId: obj.attributes.id, name: obj.attributes.name}]);
			}
			else
			{
				this.listOfUnselected =  this.listOfUnselected.concat([{ queueId: obj.attributes.id, name: obj.attributes.name}]);
			}

		}

		this.hideActionProgressBar();
		this.render();
	},
	queueError: function()
	{

		this.hideActionProgressBar();
	},
	superRender: GenericView.prototype.render,
	render: function () {
		var self = this;

		this.superRender();
		this.$el.html(this.template({ select: this.listOfSelected, unselect: this.listOfUnselected}));
	},
	events: {
	},
	isNewUser: function()
	{
		return this.id ? false : true;
	},
	setNewUserId: function(id)
	{
		this.id = id;
	},
	updateData: function(callback)
	{
			this.callback = callback;

			var self = this;
			var toAddQueues = $("#multiselect_to option:not([data-counter-id])");
			var toRemoveQueues =  $("#multiselect option[data-counter-id]");
			this.totalCalls = toAddQueues.length + toRemoveQueues.length;

			if( this.totalCalls == 0 && this.callback && this.callback.success)
			{
				this.callback.success();
				return;
			}

    		toAddQueues.each(function()
            {
				self.doAjaxCall($(this).val(), self.id, false);
            });



            toRemoveQueues.each(function()
			{
			    self.removeCounter = self.removeCounter.concat( [ $(this).attr("data-counter-id") ] );
			    $(this).removeAttr("data-counter-id");
			});

			this.doAjaxCall(null, null, true);


	},
	clearData: function()
	{
		this.listOfSelected = [];
		this.listOfUnselected = [];
		this.addCounter = [];
		this.removeCounter = [];
	},
	clearView: function()
	{
		this.clearData();
		this.venueId = null;
		this.isDisplay = false;
		this.$el.removeClass("has-error");
		this.$el.html("");

	},
	doAjaxCall: function(queueId, userId, isDelete)
	{
		var self = this;

		var url = "";
		var type = "";
		var data = "";
		url = 'rest/api/agents';
		if(isDelete)
		{
			if( this.removeCounter.length == 0)
				return;

			url = url + "?";
			type = 'DELETE';
			var params = "";
			for (var i = 0; i < this.removeCounter.length; i++) {

			  if(params != "")
					params = params + ",";

			  params = params + this.removeCounter[i];
			}

			url = url +"ids=" + encodeURIComponent(params);
			self.removeCounter = [];
		}
		else
		{
			type = 'POST';
			data = {queueId: queueId, userId: userId};

		}

		this.showActionProgressBar();

		$.when(window.ping()).then(function(resp) {
            $.ajaxDefaultQ({
                url: url,
                type: type,
                contentType: "application/json;charset=UTF-8",
                data: JSON.stringify(data),
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                }
            }).done(function(response, status, xhr){

                if(!isDelete)
                {
                    document.getElementById('queue'+ queueId).setAttribute('data-counter-id', response.data.id+"");
                    //$('#queue'+queueId).data('counter-id', response.data.id);

                }
                self.totalCalls = self.totalCalls - 1;
                if(self.totalCalls == 0 &&self.callback && self.callback.success)
                    self.callback.success(response);

                self.hideActionProgressBar();
            })
            .fail(function(response) {
                self.totalCalls = self.totalCalls - 1;
                if(self.totalCalls == 0 &&self.callback && self.callback.success)
                    self.callback.success(response);

                self.hideActionProgressBar();
            });
        });

	}
});

